// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"884":"admin","945":"dashboard"}[chunkId] + "." + {"884":"f4cfa7bf","945":"cae818e9"}[chunkId] + ".chunk.css";
};